import { createSlice } from '@reduxjs/toolkit'
import { RootState } from '../../../../root.reducer'
import { EvaluationFormSchema } from '../evaluationFormManager.validation'
import { efmApiSlice } from './efm.api'

const initialState: EvaluationFormSchema[] = []

const efmTableSlice = createSlice({
  name: 'efmTable',
  initialState,
  reducers: {
    setFormData(state, action) {
      // use this pattern to replace state
      return action.payload
    },
  },
  extraReducers: builder => {
    builder.addMatcher(
      efmApiSlice.endpoints.getAllEvalForms.matchFulfilled,
      (state, action) => {
        return action.payload
      },
    )
  },
})

export const efmTable = (state: RootState): EvaluationFormSchema[] => state.efmTable
export const { setFormData } = efmTableSlice.actions
export default efmTableSlice.reducer
